<div class="row header-container">
  <div class="col-12">
    <h1 class="page-title">{{pageTitle}}</h1>
    <p class="description">{{pageDescription}}</p>
  </div>
</div>
@if (wishListState$ | async; as wishlistState) {
  <div class="cx-item-list-row row">
    @for (entry of wishlistState?.wishList?.entries; track entry) {
      <div class="col-lg-4 col-6">
        <app-custom-wishlist-item
          [cartEntry]="entry"
          [isLoading]="loading$ | async"
          class="cx-wish-list-items product-item"
          (remove)="removeEntry($event)"
        ></app-custom-wishlist-item>
      </div>
    }
  </div>
}
<ng-template #emptyWishList>
  <h2>{{ 'wishlist.empty' | cxTranslate }}</h2>
</ng-template>




